var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 460",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,92L34.3,145.7C68.6,199,137,307,206,314.3C274.3,322,343,230,411,214.7C480,199,549,261,617,291.3C685.7,322,754,322,823,291.3C891.4,261,960,199,1029,207C1097.1,215,1166,291,1234,337.3C1302.9,383,1371,399,1440,360.3C1508.6,322,1577,230,1646,176.3C1714.3,123,1783,107,1851,138C1920,169,1989,245,2057,299C2125.7,353,2194,383,2263,398.7C2331.4,414,2400,414,2469,360.3C2537.1,307,2606,199,2674,184C2742.9,169,2811,245,2880,253C2948.6,261,3017,199,3086,153.3C3154.3,107,3223,77,3291,69C3360,61,3429,77,3497,122.7C3565.7,169,3634,245,3703,237.7C3771.4,230,3840,138,3909,107.3C3977.1,77,4046,107,4114,168.7C4182.9,230,4251,322,4320,329.7C4388.6,337,4457,261,4526,237.7C4594.3,215,4663,245,4731,276C4800,307,4869,337,4903,352.7L4937.1,368L4937.1,460L4902.9,460C4868.6,460,4800,460,4731,460C4662.9,460,4594,460,4526,460C4457.1,460,4389,460,4320,460C4251.4,460,4183,460,4114,460C4045.7,460,3977,460,3909,460C3840,460,3771,460,3703,460C3634.3,460,3566,460,3497,460C3428.6,460,3360,460,3291,460C3222.9,460,3154,460,3086,460C3017.1,460,2949,460,2880,460C2811.4,460,2743,460,2674,460C2605.7,460,2537,460,2469,460C2400,460,2331,460,2263,460C2194.3,460,2126,460,2057,460C1988.6,460,1920,460,1851,460C1782.9,460,1714,460,1646,460C1577.1,460,1509,460,1440,460C1371.4,460,1303,460,1234,460C1165.7,460,1097,460,1029,460C960,460,891,460,823,460C754.3,460,686,460,617,460C548.6,460,480,460,411,460C342.9,460,274,460,206,460C137.1,460,69,460,34,460L0,460Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.9d1b7dec0d3e0fbdad9799511107a61c.svg";
export { ForwardRef as ReactComponent };